import { moveToPending, moveToRejected, remove } from '@ms/yammer-data-support';
import { Reducer } from 'redux';

import { ThreadLoadOlderRepliesAction } from '../../domains/threadLoad/actions.types';

import { ThreadPaginations } from './types';

export type { ThreadLoadOlderRepliesAction };

const initialState: ThreadPaginations = {
  pending: { byId: {} },
  fulfilled: { byId: {} },
  rejected: { byId: {} },
};

const reducer: Reducer<ThreadPaginations, ThreadLoadOlderRepliesAction> = (state = initialState, action) => {
  switch (action.type) {
    case 'THREAD.LOAD_OLDER_REPLIES_PENDING':
      return moveToPending(state, [action.payload.id]);
    case 'THREAD.LOAD_OLDER_REPLIES_REJECTED':
      return moveToRejected(state, [action.payload.id], action.payload.error);
    case 'THREAD.LOAD_OLDER_REPLIES_FULFILLED':
      return remove(state, [action.payload.id]);
    default:
      return state;
  }
};

export default reducer;
